import shortid from "shortid";

export default (sections: any) => {
  const correctSections: any = [];
  sections.map((section: any) => {
    if (section.children.length === 0) {
      return;
    }
    if (section.children.length === 1) {
      if (section.children[0].attributes.width === "100%") {
        correctSections.push(section);
      } else {
        section.children[0].attributes.width = "100%";
        correctSections.push(section);
      }
      return;
    }
    let width = 0;
    let columnSection: any = getSerilizeColumnSection(section);
    section.children.map((column: any, index: number) => {
      const columnWidth = Number(column.attributes.width.replace("%", ""));
      if (Math.round((width + columnWidth) / 10) > 10) {
        setCorrectWidthLastColumn(columnSection, width);
        correctSections.push(columnSection);
        columnSection = getSerilizeColumnSection(section);
        width = 0;
      }
      columnSection.children.push(column);
      width += columnWidth;
      if (Math.round(width / 10) === 10) {
        correctSections.push(columnSection);
        columnSection = getSerilizeColumnSection(section);
        width = 0;
        return;
      }
      if (index === section.children.length - 1) {
        setCorrectWidthLastColumn(columnSection, width);
        correctSections.push(columnSection);
      }
    });
  });
  return correctSections;
};

function getSerilizeColumnSection(section: any) {
  return {
    tagName: "mj-section",
    attributes: section.attributes,
    children: [],
    uid: shortid.generate(),
  };
}

function setCorrectWidthLastColumn(columnSection: any, width: number) {
  const endIndex = columnSection.children.length - 1;
  columnSection.children[endIndex].attributes.width = `${
    Number(columnSection.children[endIndex].attributes.width.replace("%", "")) +
    100 -
    width
  }%`;
}
